import React, { useState, useEffect } from "react";
import { Dropdown } from "antd";
import TradeTable from "./TradeTable";
import {
  SearchOutlined,
  CheckCircleFilled,
  UserOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";
import { Col, Row } from "antd";
import { useLayout } from "../Context/LayoutContext";
import { motion, AnimatePresence } from "framer-motion";

const LotDrop = ({ children, setExpSec, }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { switchLayout, activeLay } = useLayout();
  const [animateKey, setAnimateKey] = useState(0); // trigger reanimation

  const [act, setAct] = useState([]);

  const sec = ["0.001", "0.01", "0.1", "0.2", "0.3", "0.4", "0.5", "1"];

  useEffect(() => {
    if (dropdownVisible) {
      // re-trigger animation each time dropdown opens
      setAnimateKey((prev) => prev + 1);
    }
  }, [dropdownVisible]);

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.08, duration: 0.3 },
    }),
  };

  const customPanel = (
    // <div className="layout-change v3">
    //   <div style={{ padding: "10px 0" }}>
    <Row style={{ alignItems: "center" }}>


      {sec.map((row, i) => (
        <Col span={24} key={row}>
          <motion.div
            key={`${animateKey}-${i}`} // new key on every open
            custom={i}
            initial="hidden"
            animate="visible"
            variants={itemVariants}
            className={
              act === i ? "lay-typ a3  cursor act" : "lay-typ a3 cursor"
            }
            onClick={() => {
              setExpSec(row);
              // handleSetTime(row);
              setDropdownVisible(false);
              setAct(i);
            }}
          >
            {row}
          </motion.div>
        </Col>
      ))}
    </Row>
    //   </div>
    // </div>
  );

  return (
    <Dropdown
      placement="left"
      overlay={customPanel}
      trigger={["click"]}
      overlayStyle={{
        borderRadius: "16px",
        boxShadow: "0 4px 32px rgba(0,0,0,0.35)",
        background: "#212738",
        width: "150px",
        // top: "120px"
      }}
      open={dropdownVisible}
      onOpenChange={setDropdownVisible}
    >
      {children}
    </Dropdown>
  );
};

export default LotDrop;
